import { render } from "./BaseButtonGroup.vue?vue&type=template&id=4b272428"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=js"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__